import React, { useState, useEffect } from 'react';

const DiagnosticAnalysisLoader = ({ onComplete, customTexts = null }) => {
  const [currentMessage, setCurrentMessage] = useState("");

  const defaultPhases = [
    "Analysing your results...",
    "Generating your first personalized training...",
    "Creating your first session..."
  ];
  
  const phases = customTexts || defaultPhases;

  useEffect(() => {
    let timer1, timer2, pollingInterval;
    
    console.log("DiagnosticAnalysisLoader: Starting with customTexts:", customTexts);
    console.log("DiagnosticAnalysisLoader: phases:", phases);
    
    if (!customTexts || (customTexts && customTexts.length === 3)) {
      // Set initial message
      console.log("DiagnosticAnalysisLoader: Setting initial message:", phases[0]);
      setCurrentMessage(phases[0]);
      
      // Phase 1: Analysing results (3 seconds)
      timer1 = setTimeout(() => {
        console.log("DiagnosticAnalysisLoader: Phase 2 - Setting message:", phases[1]);
        setCurrentMessage(phases[1]);
      }, 3000);

      // Phase 2: Generating training (3 seconds)
      timer2 = setTimeout(() => {
        console.log("DiagnosticAnalysisLoader: Phase 3 - Setting message:", phases[2]);
        setCurrentMessage(phases[2]);
        // Just show the message, let waitForStage1Ready handle the real logic
      }, 6000);
      
    } else if (phases.length > 1) {
      // Fallback to old behavior for custom phases
      setCurrentMessage(phases[0]);
      
      timer1 = setTimeout(() => {
        setCurrentMessage(phases[1]);
      }, 3000);

      timer2 = setTimeout(() => {
        if (onComplete) {
          onComplete();
        }
      }, 5500);
    } else {
      // Single phase
      setCurrentMessage(phases[0]);
    }

    return () => {
      if (timer1) clearTimeout(timer1);
      if (timer2) clearTimeout(timer2);
      if (pollingInterval) clearInterval(pollingInterval);
    };
  }, [onComplete, phases, customTexts]);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'white',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Manrope', sans-serif",
      gap: '32px'
    }}>
      <div style={{
        fontSize: '18px',
        fontWeight: '500',
        color: '#6B7280',
        textAlign: 'center',
        transition: 'all 0.5s ease-in-out',
        opacity: 1
      }}>
        {currentMessage}
      </div>
      
      <div style={{
        display: 'flex',
        gap: '12px',
        alignItems: 'center'
      }}>
        {['あ', 'い', 'う', 'え', 'お'].map((char, i) => (
          <div
            key={i}
            style={{
              fontSize: '24px',
              color: '#9333EA',
              fontWeight: '400',
              animation: `fadeInOut 2s ease-in-out infinite`,
              animationDelay: `${i * 0.3}s`,
              opacity: 0
            }}
          >
            {char}
          </div>
        ))}
      </div>
      
      <style>{`
        @keyframes fadeInOut {
          0%, 80%, 100% {
            opacity: 0;
            transform: translateY(0px);
          }
          20%, 60% {
            opacity: 1;
            transform: translateY(-2px);
          }
        }
      `}</style>
    </div>
  );
};

export default DiagnosticAnalysisLoader;